// extracted by mini-css-extract-plugin
export var acitonButtons = "_2z-0";
export var additionalIcon = "_2z-f";
export var block = "_2z-1";
export var blockContent = "_2z-7";
export var blockDescription = "_2z-8";
export var blockIcon = "_2z-9";
export var blockTitle = "_2z-6";
export var border = "_2z-a";
export var center = "_2z-l";
export var edge = "_2z-b";
export var edgeLabel = "_2z-c";
export var edgePath = "_2z-d";
export var error = "_2z-e";
export var flowchart = "_2z-g";
export var flowchartContent = "_2z-h";
export var highlighted = "_2z-3";
export var hover = "_2z-4";
export var icon = "_2z-i";
export var left = "_2z-m";
export var navButton = "_2z-j";
export var navButtons = "_2z-k";
export var right = "_2z-n";
export var selected = "_2z-2";
export var small = "_2z-5";